export default {
  emmitedCountry: 'Guatemala y Estados Unidos'
}
